import { render, staticRenderFns } from "./addFee.vue?vue&type=template&id=25d71c08&scoped=true"
import script from "./addFee.vue?vue&type=script&lang=js"
export * from "./addFee.vue?vue&type=script&lang=js"
import style0 from "./addFee.vue?vue&type=style&index=0&id=25d71c08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d71c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d71c08')) {
      api.createRecord('25d71c08', component.options)
    } else {
      api.reload('25d71c08', component.options)
    }
    module.hot.accept("./addFee.vue?vue&type=template&id=25d71c08&scoped=true", function () {
      api.rerender('25d71c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/costsFee/cmp/costBreakdown/addFee.vue"
export default component.exports